export default __webpack_public_path__ + "static/media/7e173bf47cd9d4d879ee8b807f560bc0.svg";